const getLayerLabel = (layer, lang) => {
    let layerLocale = layer.locales[lang] || layer.locales['en'];
    return layerLocale.name || layer.name;
};

export default getLayerLabel;
